import _ from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const getFilterData = (state: RootState) =>
  state?.homeDashboard?.filterData;

export const getIsLoading = (state: RootState) => state?.homeDashboard?.loading;

export const getHomeDashboardCards = (state: RootState) =>
  state?.homeDashboard?.helloCardData;

export const getHomeDashboardLeadMetrics = createSelector(
  [getHomeDashboardCards],
  (helloCards) => _.filter(helloCards, { type: 'leads' }) || [],
);

export const getHomeDashboardWidgetCards = createSelector(
  [getHomeDashboardCards],
  (helloCards) => _.filter(helloCards, { type: 'widget_card' }) || [],
);

export const getHelloCardPageData = (state: RootState) =>
  state?.homeDashboard?.helloCardPageData;

export const getCalendarData = (state: RootState) =>
  state?.homeDashboard?.calenderData;

export const getCalendarActivitiesList = (state: RootState) =>
  state?.homeDashboard?.activitiesList;

export const getLeadDetails = (state: RootState) =>
  state?.homeDashboard?.leadDetails;

export const getCalendarActivityDetails = (state: RootState) =>
  state?.homeDashboard?.activityDetails;

export const getRevyreHelloCards = (state: RootState) =>
  state.homeDashboard?.workflowHelloCards;

export const getWorkflowHelloCardsLoading = (state: RootState) =>
  state.homeDashboard.workflowHelloCardsLoading;

export const getWorkflowHelloCards = createSelector(
  [getRevyreHelloCards],
  (helloCards) => helloCards.filter((card) => card.type === 'workflow'),
);

export const selectModifiedActivityTypes = createSelector(
  [getCalendarActivitiesList],
  (activityTypes = []) => {
    if (!Array.isArray(activityTypes)) return [];

    const modified = activityTypes.map((activity) => ({
      ...activity,
      name: activity.module
        ? `${activity.name} · ${activity.module}`
        : activity.name,
    }));

    modified.unshift({
      code: ' ',
      name: 'All Activities',
    });

    return modified;
  },
);

export const getInputsToShowOnCalendarDetails = createSelector(
  [getCalendarActivityDetails, getLeadDetails],
  (calendarDetails, leadDetails) => {
    if (calendarDetails && Object.keys(calendarDetails).length > 0) {
      const { inputs } = calendarDetails.info;
      return inputs;
    }

    if (leadDetails && Object.keys(leadDetails).length > 0) {
      return leadDetails.inputs;
    }

    return null;
  },
);
